import { Button } from 'src/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuLabel,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from 'src/components/ui/dropdown-menu';

export const DropdownMenuDemo = ({
  rowsPerPageOptions = [],
  rowsPerPage,
  onRowsPerPageChange = (_value: number) => {},
}: {
  rowsPerPageOptions?: number[];
  rowsPerPage?: number;
  onRowsPerPageChange?: (value: number) => void;
}) => {
  const handleRowsPerPageChange = (rows: string) => {
    onRowsPerPageChange(Number(rows));
  };
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" className="opacity-60 hover:opacity-100 transition">
          {rowsPerPage}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="w-20">
        <DropdownMenuLabel>Rows per page</DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuRadioGroup
          // Radix compares values as strings.
          value={rowsPerPage === undefined ? undefined : String(rowsPerPage)}
          onValueChange={handleRowsPerPageChange}
        >
          {rowsPerPageOptions?.map((option) => (
            <DropdownMenuRadioItem key={option} value={String(option)}>
              {option}
            </DropdownMenuRadioItem>
          ))}
        </DropdownMenuRadioGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
